<template>
  <div class="card" :style="options.style?.card">
    <div class="card-header">
      <slot name="card-header">
        <div v-if="title" class="card-title text-headline fw-bold text-uppercase" :style="options.style?.title">
          <h5>{{ title }}</h5>
        </div>
      </slot>
    </div>
    <div class="card-body" :style="options.style?.body">
      <div class="card-text" :style="options.style?.text">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: { type: String, default: '' },
    options: {
      type: Object,
      default: () => ({
        style: {
          card: '',
          body: '',
          title: '',
          text: '',
        },
      }),
    },
  },
  setup() {
    return {};
  },
};
</script>
